import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import CustomButton from "./CustomButton";
import { HeaderMain } from "../styles/headerStyle";
import { useAuth } from "../context/userContext";
import CommonService from "../services/CommonService";
import { toast } from "react-toastify";

const Header = () => {
  const [openToggler, setOpenToggler] = useState(false);
  const [userDropdown, setUserDropdown] = useState(false);
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();

  // LOGOUT HANDLER START
  const handleLogout = () => {
    CommonService.get("/logout")
      .then((data) => {
        console.log(data);
        if (data?.success) {
          toast.success(data?.message);
          navigate("/");
        }
      })
      .catch((err) => toast.error(err.message));
    setAuth({
      user: null,
      loading: false,
    });
  };
  // LOGOUT HANDLER ENDS

  return (
    <HeaderMain className="gpt_header_main">
      <div className="container">
        <div className="nav_bar_sec">
          <div className="logo">
            <Link to="/">
              <img
                className="desktop"
                src="/images/logo_main.png"
                alt="Alpha Regiment desktop_logo"
              />
            </Link>
          </div>
          <div className="open_navbar_btn">
            <GiHamburgerMenu onClick={() => setOpenToggler(!openToggler)} />
          </div>
          <div className={`nav_links ${openToggler ? "open_navbar" : ""}`}>
            <div className="close_menu_btn">
              <AiOutlineClose onClick={() => setOpenToggler(!openToggler)} />
            </div>

            {auth?.user?._id ? (
              <div className="user_details_nav_link_mobile">
                <div className="userDetails">
                  <div className="profileImg">
                    <img
                      src="/images/defaultUser.png"
                      alt="Experiment Adda User Pankaj"
                    />
                  </div>
                  <div className="userName">
                    {auth?.user?.name}
                  </div>
                </div>
                {auth?.user?._id && (
                  <div className="auth_user_links">
                    <Link to={"/profile"}>Profile</Link>
                    <CustomButton onClick={handleLogout} title="Log Out" />
                  </div>
                )}
              </div>
            ) : (
              <img
                className="sideNavdesktopImg"
                src="/images/logo_main.png"
                alt="Alpha Regiment desktop_logo"
              />
            )}

            <div className="nav_link dropdown_nav">
              {auth?.user?._id ? (
                <div className="auth_profile_dropdown">
                  <button
                    className={`sign_up_btn dashboard_btn ${
                      auth?.user?._id ? "profile_header_btn" : ""
                    }`}
                    onClick={() => setUserDropdown(!userDropdown)}
                  >
                    <img
                      src="/images/defaultUser.png"
                      alt="Experiment Adda User Pankaj"
                    />
                    {auth?.user?.name?.slice(0, 10)}
                    {userDropdown ? (
                      <BsFillCaretUpFill />
                    ) : (
                      <BsFillCaretDownFill />
                    )}
                  </button>
                  <div
                    className={`nav_dropdown_links ${
                      userDropdown ? "show_nav_dropdown" : ""
                    }`}
                  >
                    <Link to="/profile">Profile</Link>
                    <button onClick={handleLogout} className="logout_btn">
                      logout
                    </button>
                  </div>
                </div>
              ) : (
                <div className="headerSign_btns">
                  <CustomButton
                    className="sign_up_btn signIn"
                    onClick={() => navigate("/login")}
                    title="Sign In"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </HeaderMain>
  );
};

export default Header;
